import React from 'react';

import type {ComponentType} from 'react';
type EditableProps = {
  editing: boolean;
  setEditing: (arg0: boolean) => void;
};

const pointerCursorStyle = {
  cursor: 'pointer',
};
export default function editableEnhancer<T, V>(
  ViewComponent: ComponentType<T>,
  EditComponent: ComponentType<V>
) {
  return (props: T & V & EditableProps) => {
    const handleClick = (e: React.MouseEvent<any>) => {
      const isChildren = e.currentTarget.contains(e.target);

      if (isChildren && !props.editing) {
        props.setEditing(true);
      }
    };

    return (
      <div
        onClick={handleClick}
        style={props.editing ? undefined : pointerCursorStyle}
      >
        {props.editing ? (
          <EditComponent {...props} />
        ) : (
          <ViewComponent {...props} />
        )}
      </div>
    );
  }; //onClickOutside(GenericEditable);
}
